import { SortOption } from '../../../ui/components/baseTable/dtos/SortOption.dto'
import { TableColumn } from '../../../ui/components/baseTable/dtos/TableColumn.dto'

export class ExclusionZoneTableColumnsFactory {
	static make(sortOptions: SortOption[]): TableColumn[] {
		return [
			{
				name: 'Código',
				key: 'code',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'code')?.direction,
			},
			{
				name: 'Fazenda',
				key: 'monitoredAreaName',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'monitoredAreaName')?.direction,
			},
			{
				name: 'Área da zona',
				key: 'zonesAreaLabel',
				enableSort: true,
				sortKey: 'area',
				sortActive: sortOptions.find((sort) => sort.key === 'area')?.direction,
			},
			{
				name: 'Número de áreas',
				key: 'zoneCount',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'zoneCount')?.direction,
			},
		]
	}
}
